import * as React from 'react';
import './CheckboxComponent.css';

import {faCheckSquare, faSquare} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {t} from 'react-multi-lang';

interface ICheckboxProps {
    checked: boolean,
    onClick: () => any,
}

class CheckboxComponent extends React.Component<ICheckboxProps> {
    constructor(props: ICheckboxProps) {
        super(props);
    }

    public render() {
        return (
            <div onClick={this.props.onClick} className="w_horizontal_center_flex w_checkbox"
                 title={t('overview.checkbox_hover')}>
                {this.props.checked ?
                    <FontAwesomeIcon icon={faCheckSquare} size="lg" color="#1D3D53"/>
                    :
                    <FontAwesomeIcon icon={faSquare} size="lg" color="#1D3D53"/>
                }
            </div>
        );
    }
}

export default CheckboxComponent;


// WEBPACK FOOTER //
// ./src/components/CheckboxComponent/CheckboxComponent.tsx